export default {
  title: 'Modelltraining',
  subtitle: 'Erstelle ein neues Modell für maschinelles Lernen basierend auf anderen Sensordaten.',
  saveAction: 'Modell trainieren',
  selectTargetHeadline: 'Zielsensor',
  selectFeaturesHeadline: 'Funktionssensor',
  selectTrainingData: 'Trainingsdaten',
  configureModel: 'Modellkonfiguration',
  modelDisplayName: 'Modellname',
};
